import Image from '../../core/Image';
import View from '../../core/View';

type Props = {
  appDialogMobileImage?: string | null;
  appDialogTabletImage?: string | null;
};
const AppDialogImageTypePreview = ({ appDialogMobileImage, appDialogTabletImage }: Props) => {
  return (
    <View>
      <View
        sx={{
          position: 'relative',
          width: '100%',
          maxWidth: 250,
          margin: '0 auto',
          borderRadius: '20px',
          aspectRatio: '300 / 500',
          overflow: 'hidden',
          backgroundColor: 'white',
          boxShadow: ' 0px 4px 10px 0px rgba(0, 0, 0, 0.2)',
        }}
      >
        {appDialogMobileImage ? (
          <Image src={appDialogMobileImage} alt={'모바일 전용 이미지'} fill style={{ objectFit: 'cover' }} />
        ) : null}
      </View>
      <View
        sx={{
          position: 'relative',
          width: '100%',
          maxWidth: 500,
          margin: '0 auto',
          borderRadius: '20px',
          aspectRatio: '1080 / 500',
          overflow: 'hidden',
          backgroundColor: 'white',

          marginTop: 4,
          boxShadow: ' 0px 4px 10px 0px rgba(0, 0, 0, 0.2)',
        }}
      >
        {appDialogTabletImage ? (
          <Image src={appDialogTabletImage} alt={'태블릿 전용 이미지'} fill style={{ objectFit: 'cover' }} />
        ) : null}
      </View>
    </View>
  );
};

export default AppDialogImageTypePreview;
